// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1CompaniesUpdateSchema } from './v1/companies/updateSchema';
import { v1CompanySchema } from './v1/companySchema';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnprocessableEntityErrorSchema } from './v1/unprocessableEntityErrorSchema';

export const put11AccountIdClientsIdPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID for the client you want to update"),
  id: z.number().int().describe("Client ID to update"),
});

export const put11AccountIdClientsIdHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Client details
 */
export const put11AccountIdClientsId200Schema = z.lazy(() => v1CompanySchema);

/**
 * @description Forbidden - Insufficient permissions to update client
 */
export const put11AccountIdClientsId403Schema = z.lazy(() => v1ForbiddenErrorSchema);

/**
 * @description Client not found
 */
export const put11AccountIdClientsId404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Unprocessable Entity
 */
export const put11AccountIdClientsId422Schema = z.lazy(() => v1UnprocessableEntityErrorSchema);

export const put11AccountIdClientsIdMutationRequestSchema = z.lazy(() => v1CompaniesUpdateSchema);

export const put11AccountIdClientsIdMutationResponseSchema = z.lazy(() => put11AccountIdClientsId200Schema);
